import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "user-videos" }
const _hoisted_2 = { class: "ui-toggle-container" }
const _hoisted_3 = { class: "ui-toggle" }
const _hoisted_4 = { class: "videos-container" }
const _hoisted_5 = {
  key: 0,
  class: "no-files"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "video-form" }
const _hoisted_8 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_VideoEdit = _resolveComponent("VideoEdit")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Search, {
      id: "search-user-videos",
      class: "style-standard",
      searchOpen: "",
      onFilterSearch: _ctx.inputSearchTerm
    }, null, 8, ["onFilterSearch"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass({ selected: _ctx.selectedUiType === 'grid' }),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleUi && _ctx.toggleUi(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "icon",
            icon: "th-large"
          })
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass({ selected: _ctx.selectedUiType === 'table' }),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleUi && _ctx.toggleUi(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "icon",
            icon: "list-ul"
          })
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.isFetching && !_ctx.allVideos.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("img", {
              src: require('@/assets/img/file_management.svg'),
              alt: ""
            }, null, 8, _hoisted_6),
            _cache[4] || (_cache[4] = _createElementVNode("h4", null, "No Videos Found", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", null, "Add a video for the user if required.", -1))
          ]))
        : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), {
            key: 1,
            tableHeadings: _ctx.tableHeadings,
            preparedVideos: _ctx.preparedVideos,
            videos: _ctx.allVideos,
            videoContents: _ctx.videoContents,
            totalRows: _ctx.totalRows,
            headingsData: _ctx.headingsData,
            sortOrder: _ctx.sortOrder,
            onViewVideo: _ctx.viewVideo,
            onClickCell: _ctx.handleClickCell,
            onHandleClickSort: _ctx.handleClickSort
          }, null, 40, ["tableHeadings", "preparedVideos", "videos", "videoContents", "totalRows", "headingsData", "sortOrder", "onViewVideo", "onClickCell", "onHandleClickSort"]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Modal, {
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showModal) = $event)),
        title: "action.type.video"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VideoEdit, {
            modelValue: _ctx.model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model) = $event)),
            editable: false,
            onValidUpdate: _ctx.handleValidUpdate,
            onNewFile: _ctx.handleNewFile
          }, null, 8, ["modelValue", "onValidUpdate", "onNewFile"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              text: "common.cancel-action",
              size: "sm",
              variant: "secondary",
              onClick: _ctx.cancelVideoChanges
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              text: "common.save",
              size: "sm",
              disabled: !_ctx.isValid,
              onClick: _ctx.handleSave
            }, null, 8, ["disabled", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}